(() => {
  const init = (section) => {
    if (section.dataset.mhReviewsReady) return;
    const widget = section.querySelector('[data-mh-reviews-widget]');
    const button = section.querySelector('[data-mh-reviews-toggle]');
    if (!widget || !button) return;
    const limit = 17;
    let expanded = false;
    const reviews = () => [...widget.querySelectorAll('.jdgm-rev')];
    const update = () => {
      const items = reviews();
      items.forEach((item, index) => item.toggleAttribute('data-mh-review-hidden', index >= limit));
      section.toggleAttribute('data-mh-reviews-collapsed', !expanded);
      button.hidden = items.length <= limit;
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? 'Show fewer reviews' : 'See all reviews';
    };
    button.addEventListener('click', () => {
      expanded = !expanded;
      update();
      if (expanded) {
        const next = reviews()[limit];
        if (next) {
          next.setAttribute('tabindex', '-1');
          next.focus({ preventScroll: true });
          next.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      } else {
        button.focus({ preventScroll: true });
        button.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
    });
    widget.addEventListener('change', () => { expanded = false; update(); });
    new MutationObserver(update).observe(widget, { childList: true, subtree: true });
    section.dataset.mhReviewsReady = 'true';
    update();
  };
  document.querySelectorAll('[data-mh-reviews-disclosure]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-mh-reviews-disclosure]').forEach(init);
  });
})();
